/**
 * Splits markdown content into sections at heading boundaries.
 * Each section contains the heading line plus all content until the next heading.
 *
 * @param {string} markdown - Raw markdown string
 * @returns {Array<{id: string, heading: string, headingLevel: number, content: string}>}
 */
export function parseMarkdownSections(markdown) {
  if (!markdown || typeof markdown !== 'string') return [];

  const lines = markdown.split('\n');
  const sections = [];
  let currentSection = null;

  for (const line of lines) {
    const headingMatch = line.match(/^(#{1,6})\s+(.*)/);

    if (headingMatch) {
      // Save previous section
      if (currentSection) {
        sections.push(currentSection);
      }
      currentSection = {
        id: `section-${sections.length}`,
        heading: headingMatch[2].trim(),
        headingLevel: headingMatch[1].length,
        content: line,
      };
    } else {
      if (currentSection) {
        currentSection.content += '\n' + line;
      } else {
        // Content before first heading — treat as preamble section
        currentSection = {
          id: `section-${sections.length}`,
          heading: '',
          headingLevel: 0,
          content: (currentSection?.content ? currentSection.content + '\n' : '') + line,
        };
      }
    }
  }

  // Push the last section
  if (currentSection) {
    sections.push(currentSection);
  }

  return sections;
}

/**
 * Joins sections back into a single markdown string.
 *
 * @param {Array<{content: string}>} sections
 * @returns {string}
 */
export function reconstructMarkdown(sections) {
  return sections.map((s) => s.content.trim()).join('\n\n');
}
